import React from 'react';

import { Text, View } from '@react-pdf/renderer';

import { commonStyles } from 'src/common/pdf/common.styles';

import { currencyFormatter } from '../../forms/cells/utils';
import { styles } from '../styles';

interface InvoicePDFFooterProps {
  invoiceNotes: string;
  subTotalAmount: number;
  adjustmentAmount: number;
  totalAmount: number;
  paymentLine?: React.ReactNode;
  refundLine?: React.ReactNode;
}

export function InvoicePDFFooter({
  invoiceNotes,
  subTotalAmount,
  adjustmentAmount,
  totalAmount,
  paymentLine,
  refundLine,
}: InvoicePDFFooterProps) {
  return (
    <View style={{ justifyContent: 'space-between', flexDirection: 'row' }}>
      <View style={{ paddingTop: 4, width: '65%' }}>
        <Text
          style={[
            commonStyles.textMd,
            commonStyles.upper,
            commonStyles.strong,
            commonStyles.letterSpacingSm,
          ]}
        >
          Notes:
        </Text>
        <Text>{invoiceNotes}</Text>
      </View>
      <View
        style={[
          {
            width: '30%',
          },
        ]}
      >
        <View style={styles.subTotalStyle}>
          <Text style={commonStyles.strong}>Subtotal</Text>
          <Text>{currencyFormatter(subTotalAmount)}</Text>
        </View>
        {adjustmentAmount ? (
          <View style={styles.subTotalStyle}>
            <Text style={commonStyles.strong}>Adjustments</Text>
            <Text>{currencyFormatter(adjustmentAmount)}</Text>
          </View>
        ) : null}
        {paymentLine ? paymentLine : null}
        {refundLine ? refundLine : null}
        <View
          style={[
            styles.subTotalStyle,
            {
              backgroundColor: '#0caca64a',
            },
          ]}
        >
          <Text style={commonStyles.strong}>Total Due</Text>
          <Text>{currencyFormatter(totalAmount)}</Text>
        </View>
      </View>
    </View>
  );
}
